import { formatDate } from '@/helpers/general'
import { User } from './../Users/constants'
import { Range } from './types'

export const mkSummaryQuery = (user: User, target: string, range: Range) => `
  SELECT entities.name                                              AS 'entity name',
         vendors.name                                               AS 'client name',
         CONVERT_TZ(min(trips.trip_started_at), '+00:00', '+02:00') AS 'first trip start time',
         CONVERT_TZ(max(trips.trip_ended_at), '+00:00', '+02:00')   AS 'last trip end time',
         count(*)                                                   AS 'amount of trips',
         ROUND(sum(trips.distance) / 1000, 1)                       AS 'total distance (km)',
         ROUND(sum(trips.duration) / 3600, 1)                       AS 'total duration (h)',
         ROUND(avg(trips.average_speed), 1)                         AS 'average speed (km/h)',
         ROUND(max(trips.max_speed), 1)                             AS 'maximum speed (km/h)',
         ROUND(entities.odo / 1000)                                 AS 'ODO (km)',
         entities.active                                            AS 'target group'
  FROM trips
         LEFT JOIN device_entity_user ON device_entity_user.imei = trips.imei
         RIGHT JOIN entities ON entities.id = device_entity_user.entity_id
         LEFT JOIN vendors ON vendors.id = entities.vendor_id
  WHERE entities.${user.sub_vendor.type}_id = '${user.sub_vendor.id}'
    AND entities.active = '${target}'
    AND date(trips.trip_ended_at) >= '${formatDate(new Date(range.till), 'YYYY-MM-DD')}'
    AND date(trips.trip_started_at) < '${formatDate(new Date(range.from), 'YYYY-MM-DD')}'
    AND trips.deleted_at IS NULL
    AND entities.deleted_at IS NULL
  GROUP BY entities.id
  ORDER by vendors.name;
`

export const mkAllQuery = (user: User, target: string, range: Range) => `
  SELECT entities.name                                         AS 'entity name',
         CONVERT_TZ(trips.trip_started_at, '+00:00', '+02:00') AS 'start time',
         trips.start_address                                   AS 'start address',
         CONVERT_TZ(trips.trip_ended_at, '+00:00', '+02:00')   AS 'end time',
         trips.end_address                                     AS 'end address',
         ROUND(trips.distance / 1000, 1)                       AS 'distance (km)',
         ROUND(trips.duration / 60)                            AS 'duration (minutes)',
         ROUND(trips.average_speed, 1)                         AS 'average speed (km/h)'
  FROM trips
         LEFT JOIN device_entity_user ON device_entity_user.imei = trips.imei
         RIGHT JOIN entities ON entities.id = device_entity_user.entity_id
  WHERE entities.${user.sub_vendor.type}_id = '${user.sub_vendor.id}'
    AND entities.active = '${target}'
    AND date(trips.trip_ended_at) >= '${formatDate(new Date(range.till), 'YYYY-MM-DD')}'
    AND date(trips.trip_ended_at) <= '${formatDate(new Date(range.from), 'YYYY-MM-DD')}'
    AND trips.deleted_at IS NULL
  ORDER BY entities.name, trip_started_at DESC;
`
